import { render, staticRenderFns } from "./Home.new-global-offers.vue?vue&type=template&id=20789ce8&scoped=true&"
import script from "./Home.new-global-offers.vue?vue&type=script&lang=js&"
export * from "./Home.new-global-offers.vue?vue&type=script&lang=js&"
import style0 from "./Home.new-global-offers.vue?vue&type=style&index=0&id=20789ce8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20789ce8",
  null
  
)

export default component.exports